import Lenis from 'lenis';

let lenis = null;

export function initLenis() {
    lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return lenis;
}

export function destroyLenis() {
    if (lenis) {
        lenis.destroy();
        lenis = null;
    }
}

export function scrollToTop() {
    if (lenis) {
        lenis.scrollTo(0, { immediate: true });
    } else {
        window.scrollTo(0, 0);
    }
}

export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenis) {
        lenis.scrollTo(el, { offset: -90 });
    } else {
        el.scrollIntoView({ behavior: 'smooth' });
    }
}
